import React from 'react';

import { Container } from './styles';

const Footer: React.FC = () => {
  return (
    <Container>
      <p>
        OxyHost & BRX Digital
        <br />
        Todos os direitos reservados
      </p>
    </Container>
  );
};

export default Footer;
